var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","background-color":"#E5EAF0"}},[_c('div',{staticClass:"menu-items"},[_c('MenuBar',{attrs:{"menu":_vm.botao},on:{"mini":function($event){_vm.botao=$event}}}),_c('div',{staticClass:"header"},[_c('div',{staticClass:"content"},[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }